import React from 'react';

import smallCSS from './SmallStyle.css';
import largeCSS from './LargeStyle.css'

/*
 * Switch Component
 * Note: checked and onClick are required for Switch component to function.
 *   The disabled, onText, offText, and id props are optional.
 * Usage: <ToggleSwitch checked={value} onClick={handleSwitchToggleEvent}} />
 */

const Switch = ({ checked, disabled, onText, offText, id, style, onChange }) => {
    const displayLargeSwitch = onText === 'ENABLED'
    const baseClass = {
        ...style,
        position: 'relative',
        display: 'inline-block',
        height: 34,
        fontSize: 13,
    }
    const largeSwitchClass = {
        ...baseClass,
        width: '6.4rem',
    }
    const smallSwitchClass = {
        ...baseClass,
        width: '4.4rem',
    }


    return ( displayLargeSwitch
        ? // Return the large version of the switch 
        (
            <label id={id} style={largeSwitchClass}>
                <input type="checkbox" style={{ display: 'none' }} checked={checked} onChange={onChange} disabled={disabled} />
                <span className={`${largeCSS.slider} ${!checked ? largeCSS.sliderOFF : ''} ${disabled ? largeCSS.disabled : ''}`}>
                    <p className={largeCSS.status}>{checked ? onText : offText}</p>
                </span>
            </label>
        )
        : // Return the small version of the switch
        (
            <label id={id} style={smallSwitchClass}>
                <input type="checkbox" style={{ display: 'none' }} checked={checked} onChange={onChange} disabled={disabled} />
                <span className={`${smallCSS.slider} ${!checked ? smallCSS.sliderOFF : ''} ${disabled ? smallCSS.disabled : ''}`}>
                    <p className={smallCSS.status}>{checked ? onText : offText}</p>
                </span>
            </label>
        )
    )
}

Switch.defaultProps = {
    onText: 'ON',
    offText: 'OFF'
}

export default Switch;